import { render, staticRenderFns } from "./ApiRest.vue?vue&type=template&id=28e6d2d0"
import script from "./ApiRest.vue?vue&type=script&lang=js"
export * from "./ApiRest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports